/* =============================================================
   VFW Gallery — Product Build Gallery + Main Gallery + Lightbox
   ============================================================= */
(function () {
  'use strict';

  /* ── Tiny helpers ── */
  var $ = function (el, sel) { return el.querySelector(sel); };
  var $$ = function (el, sel) { return Array.prototype.slice.call(el.querySelectorAll(sel)); };

  /* ── Scroll lock ── */
  var _scrollY = 0;
  function lockScroll() {
    _scrollY = window.pageYOffset;
    document.body.style.cssText =
      'overflow:hidden;position:fixed;top:-' + _scrollY + 'px;left:0;right:0;';
  }
  function unlockScroll() {
    document.body.style.cssText = '';
    window.scrollTo(0, _scrollY);
  }

  /* ── HTML escape ── */
  function esc(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ══════════════════════════════════════════════════════════════
     LIGHTBOX (singleton — created once, shared across galleries)

     Phase 2 API:
       Lightbox.open(images, meta, startIndex)
         images:     [{src, thumb, alt}]  — photos for this build
         meta:       {vehicle, size, finish, chassis, fitment, notes, shopUrl}
         startIndex: integer (default 0)

     Prev/Next navigates between photos within the build.
     Meta panel stays static for the build's lifetime in the lightbox.
     ══════════════════════════════════════════════════════════════ */

  var Lightbox = (function () {
    var el = null;
    var mainImg, counter, prevBtn, nextBtn, infoToggle, drawer, thumbsEl, thumbStrip;
    var drawerContent, productCard, shopBtn, helpBtn;
    var drawerScroll, scrollFade;
    var state = { images: [], meta: {}, index: 0, drawerOpen: true };

    function create() {
      var div = document.createElement('div');
      div.innerHTML = [
        '<div class="vfw-lightbox" id="vfw-gallery-lightbox" role="dialog" aria-modal="true" aria-label="Build Gallery" hidden>',
        '  <div class="vfw-lightbox__backdrop"></div>',
        '  <div class="vfw-lightbox__shell">',
        '    <div class="vfw-lightbox__topbar">',
        '      <span class="vfw-lightbox__counter" aria-live="polite"></span>',
        '      <div class="vfw-lightbox__info-wrap">',
        '        <button class="vfw-lightbox__info-toggle" type="button" aria-expanded="true">Hide Info</button>',
        '        <span class="vfw-lightbox__info-hint" aria-hidden="true">',
        '          <svg class="vfw-lightbox__info-hint-chev" viewBox="0 0 8 14" width="7" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="1,1 7,7 1,13"/></svg>',
        '          <svg class="vfw-lightbox__info-hint-chev" viewBox="0 0 8 14" width="7" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="1,1 7,7 1,13"/></svg>',
        '          <svg class="vfw-lightbox__info-hint-chev" viewBox="0 0 8 14" width="7" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="1,1 7,7 1,13"/></svg>',
        '        </span>',
        '      </div>',
        '      <button class="vfw-lightbox__close" type="button" aria-label="Close gallery">',
        '        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round">',
        '          <line x1="3" y1="3" x2="17" y2="17"/><line x1="17" y1="3" x2="3" y2="17"/>',
        '        </svg>',
        '      </button>',
        '    </div>',
        '    <div class="vfw-lightbox__body">',
        '      <div class="vfw-lightbox__stage">',
        '        <button class="vfw-lightbox__nav vfw-lightbox__nav--prev" type="button" aria-label="Previous photo">',
        '          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>',
        '        </button>',
        '        <div class="vfw-lightbox__img-wrap">',
        '          <img class="vfw-lightbox__main-img" src="" alt="" loading="eager">',
        '        </div>',
        '        <button class="vfw-lightbox__nav vfw-lightbox__nav--next" type="button" aria-label="Next photo">',
        '          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg>',
        '        </button>',
        '      </div>',
        '      <aside class="vfw-lightbox__drawer" aria-label="Build information">',
        '        <div class="vfw-lightbox__drawer-scroll">',
        '          <div class="vfw-lightbox__drawer-content"></div>',
        '          <div class="vfw-lightbox__scroll-fade" aria-hidden="true"></div>',
        '        </div>',
        '        <div class="vfw-lightbox__product-card" hidden>',
        '          <img class="vfw-lb-product__img" src="" alt="" loading="lazy">',
        '          <div class="vfw-lb-product__details">',
        '            <p class="vfw-lb-product__name"></p>',
        '            <p class="vfw-lb-product__price"></p>',
        '          </div>',
        '        </div>',
        '        <div class="vfw-lightbox__drawer-cta">',
        '          <a href="#" class="vfw-lightbox__shop-btn" hidden>Shop This Wheel</a>',
        '          <a href="/pages/contact" class="vfw-lightbox__help-btn">Get Fitment Help</a>',
        '        </div>',
        '      </aside>',
        '    </div>',
        '    <div class="vfw-lightbox__thumbstrip">',
        '      <div class="vfw-lightbox__thumbs"></div>',
        '    </div>',
        '  </div>',
        '</div>'
      ].join('');
      document.body.appendChild(div.firstElementChild);
    }

    function init() {
      if (el) return;
      create();
      el = document.getElementById('vfw-gallery-lightbox');
      mainImg = $(el, '.vfw-lightbox__main-img');
      counter = $(el, '.vfw-lightbox__counter');
      prevBtn = $(el, '.vfw-lightbox__nav--prev');
      nextBtn = $(el, '.vfw-lightbox__nav--next');
      infoToggle = $(el, '.vfw-lightbox__info-toggle');
      drawer = $(el, '.vfw-lightbox__drawer');
      drawerContent = $(el, '.vfw-lightbox__drawer-content');
      drawerScroll = $(el, '.vfw-lightbox__drawer-scroll');
      scrollFade = $(el, '.vfw-lightbox__scroll-fade');
      thumbsEl = $(el, '.vfw-lightbox__thumbs');
      thumbStrip = $(el, '.vfw-lightbox__thumbstrip');
      productCard = $(el, '.vfw-lightbox__product-card');
      shopBtn = $(el, '.vfw-lightbox__shop-btn');
      helpBtn = $(el, '.vfw-lightbox__help-btn');
      bindEvents();
    }

    function updateScrollFade() {
      if (!drawerScroll || !scrollFade) return;
      var atBottom = drawerScroll.scrollTop + drawerScroll.clientHeight >= drawerScroll.scrollHeight - 4;
      scrollFade.style.opacity = atBottom ? '0' : '1';
    }

    function bindEvents() {
      $(el, '.vfw-lightbox__backdrop').addEventListener('click', close);
      $(el, '.vfw-lightbox__close').addEventListener('click', close);

      prevBtn.addEventListener('click', function () { go(state.index - 1); });
      nextBtn.addEventListener('click', function () { go(state.index + 1); });

      drawerScroll.addEventListener('scroll', updateScrollFade);

      infoToggle.addEventListener('click', function () {
        state.drawerOpen = !state.drawerOpen;
        drawer.setAttribute('aria-hidden', state.drawerOpen ? 'false' : 'true');
        infoToggle.setAttribute('aria-expanded', state.drawerOpen ? 'true' : 'false');
        infoToggle.textContent = state.drawerOpen ? 'Hide Info' : 'Show Info';
        setTimeout(updateScrollFade, 50);
      });

      document.addEventListener('keydown', function (e) {
        if (el.hasAttribute('hidden')) return;
        if (e.key === 'Escape') { close(); }
        else if (e.key === 'ArrowLeft') { go(state.index - 1); }
        else if (e.key === 'ArrowRight') { go(state.index + 1); }
      });
    }

    function preload(src) {
      if (!src) return;
      var img = new Image();
      img.src = src;
    }

    /* Open lightbox for a build's image set */
    function open(images, meta, startIndex) {
      init();
      state.images = images || [];
      state.meta = meta || {};
      state.index = Math.max(0, Math.min(startIndex || 0, state.images.length - 1));

      buildThumbs();
      updateDrawer(state.meta);
      renderImage(state.index);

      /* Drawer initial state: closed on mobile, open on desktop */
      var isMobile = window.innerWidth <= 900;
      state.drawerOpen = !isMobile;
      drawer.setAttribute('aria-hidden', isMobile ? 'true' : 'false');
      infoToggle.setAttribute('aria-expanded', isMobile ? 'false' : 'true');
      infoToggle.textContent = isMobile ? 'Show Info' : 'Hide Info';

      /* Preload the next few images so navigation feels instant */
      for (var p = 1; p <= 3 && p < state.images.length; p++) {
        preload(state.images[p].src);
      }

      el.removeAttribute('hidden');
      el.setAttribute('aria-hidden', 'false');
      lockScroll();
      $(el, '.vfw-lightbox__close').focus();
    }

    function close() {
      if (!el) return;
      el.setAttribute('hidden', '');
      el.setAttribute('aria-hidden', 'true');
      unlockScroll();
    }

    function go(index) {
      if (!state.images.length) return;
      index = Math.max(0, Math.min(index, state.images.length - 1));
      state.index = index;
      renderImage(index);
      preload((state.images[index + 1] || {}).src);
      preload((state.images[index - 1] || {}).src);
    }

    /* Render current image within the build */
    function renderImage(index) {
      var img = state.images[index];
      if (!img) return;

      mainImg.classList.add('is-loading');
      mainImg.src = img.src;
      mainImg.alt = img.alt || '';
      mainImg.onload = function () { mainImg.classList.remove('is-loading'); };

      /* Counter: only shown when > 1 image */
      counter.textContent = state.images.length > 1
        ? (index + 1) + ' of ' + state.images.length
        : '';

      prevBtn.disabled = index === 0;
      nextBtn.disabled = index === state.images.length - 1;

      /* Sync thumb strip active state */
      $$(el, '.vfw-lightbox__thumb').forEach(function (th, i) {
        th.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      var activeTh = thumbsEl.children[index];
      if (activeTh) activeTh.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }

    /* Build thumbnail strip — hidden when only 1 image */
    function buildThumbs() {
      thumbsEl.innerHTML = '';
      if (thumbStrip) thumbStrip.hidden = state.images.length <= 1;

      state.images.forEach(function (img, i) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'vfw-lightbox__thumb';
        btn.setAttribute('aria-current', 'false');
        btn.setAttribute('aria-label', 'Photo ' + (i + 1));
        if (img.thumb) {
          var th = document.createElement('img');
          th.src = img.thumb;
          th.alt = img.alt || '';
          th.loading = 'lazy';
          btn.appendChild(th);
        }
        btn.addEventListener('click', function () { go(i); });
        thumbsEl.appendChild(btn);
      });
    }

    /* Render build info into drawer — called once per open, not per image */
    function updateDrawer(meta) {
      if (!drawerContent) return;
      var html = '';

      /* Vehicle heading */
      var vehicleName = meta.vehicle;
      if (!vehicleName && (meta.make || meta.model)) {
        vehicleName = [meta.generation, meta.make, meta.model].filter(Boolean).join(' ');
      }
      if (vehicleName) {
        html += '<p class="vfw-lb-info__vehicle">' + esc(vehicleName) + '</p>';
      }

      /* Vehicle section */
      if (meta.make || meta.model || meta.generation || meta.chassis || meta.brake) {
        html += '<p class="vfw-lb-info__section-head">Vehicle</p>';
        if (meta.make)       { html += '<p class="vfw-lb-info__label">Make</p><p class="vfw-lb-info__value">' + esc(meta.make) + '</p>'; }
        if (meta.model)      { html += '<p class="vfw-lb-info__label">Model</p><p class="vfw-lb-info__value">' + esc(meta.model) + '</p>'; }
        if (meta.generation) { html += '<p class="vfw-lb-info__label">Generation</p><p class="vfw-lb-info__value">' + esc(meta.generation) + '</p>'; }
        if (meta.chassis)    { html += '<p class="vfw-lb-info__label">Chassis</p><p class="vfw-lb-info__value">' + esc(meta.chassis) + '</p>'; }
        if (meta.brake)      { html += '<p class="vfw-lb-info__label">Brake Setup</p><p class="vfw-lb-info__value">' + esc(meta.brake) + '</p>'; }
      }

      /* Wheel section */
      if (meta.design || meta.size || meta.finish || meta.tireSize || meta.backspacing) {
        html += '<div class="vfw-lb-info__rule"></div>';
        html += '<p class="vfw-lb-info__section-head">Wheel &amp; Tire</p>';
        if (meta.design)      { html += '<p class="vfw-lb-info__label">Design</p><p class="vfw-lb-info__value">' + esc(meta.design) + '</p>'; }
        if (meta.size)        { html += '<p class="vfw-lb-info__label">Wheel Size</p><p class="vfw-lb-info__value">' + esc(meta.size) + '</p>'; }
        if (meta.finish)      { html += '<p class="vfw-lb-info__label">Finish</p><p class="vfw-lb-info__value">' + esc(meta.finish) + '</p>'; }
        if (meta.tireSize)    { html += '<p class="vfw-lb-info__label">Tire Size</p><p class="vfw-lb-info__value">' + esc(meta.tireSize) + '</p>'; }
        if (meta.backspacing) { html += '<p class="vfw-lb-info__label">Backspacing</p><p class="vfw-lb-info__value">' + esc(meta.backspacing) + '</p>'; }
      }

      /* Notes */
      if (meta.notes) {
        html += '<div class="vfw-lb-info__rule"></div>';
        html += '<p class="vfw-lb-info__label">Notes</p>';
        html += '<p class="vfw-lb-info__value">' + esc(meta.notes) + '</p>';
      }

      drawerContent.innerHTML = html;
      if (drawerScroll) drawerScroll.scrollTop = 0;
      setTimeout(updateScrollFade, 50);

      /* Product card */
      if (productCard) {
        if (meta.productImg || meta.productTitle) {
          var imgEl  = $(productCard, '.vfw-lb-product__img');
          var nameEl = $(productCard, '.vfw-lb-product__name');
          var priceEl = $(productCard, '.vfw-lb-product__price');
          if (imgEl)  { imgEl.src = meta.productImg || ''; imgEl.alt = meta.productTitle || ''; imgEl.hidden = !meta.productImg; }
          if (nameEl)  nameEl.textContent = meta.productTitle || '';
          if (priceEl) priceEl.textContent = meta.productPrice || '';
          productCard.removeAttribute('hidden');
        } else {
          productCard.setAttribute('hidden', '');
        }
      }

      if (shopBtn) {
        if (meta.shopUrl) {
          shopBtn.href = meta.shopUrl;
          shopBtn.removeAttribute('hidden');
        } else {
          shopBtn.setAttribute('hidden', '');
        }
      }
    }

    return { open: open, close: close };
  })();

  /* ══════════════════════════════════════════════════════════════
     PRODUCT GALLERY — filter + lightbox trigger
     Each item has a single image (data-lb-src); wrapped in array
     to use the same Lightbox.open(images, meta) API.
     ══════════════════════════════════════════════════════════════ */

  function initProductGallery(section) {
    var grid     = $(section, '.vfw-pg__grid');
    var emptyEl  = $(section, '.vfw-pg__empty');
    var resetBtn = $(section, '.vfw-pg__reset');
    var selects  = $$(section, '.vfw-pg__select');
    var items    = grid ? $$(grid, '.vfw-pg__item') : [];

    if (!grid || !items.length) return;

    function applyFilters() {
      var active = {};
      selects.forEach(function (sel) {
        if (sel.value) active[sel.getAttribute('data-filter')] = sel.value;
      });

      var visible = 0;
      items.forEach(function (item) {
        var match = Object.keys(active).every(function (key) {
          return item.getAttribute('data-' + key) === active[key];
        });
        item.hidden = !match;
        if (match) visible++;
      });

      if (emptyEl) emptyEl.hidden = visible > 0;
    }

    selects.forEach(function (sel) {
      sel.addEventListener('change', applyFilters);
    });

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        selects.forEach(function (sel) { sel.value = ''; });
        applyFilters();
      });
    }

    /* Click → lightbox (single image per product gallery item) */
    items.forEach(function (item) {
      var btn = $(item, '.vfw-pg__img-btn');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var src   = item.getAttribute('data-lb-src') || '';
        var thumb = item.getAttribute('data-lb-thumb') || src;
        var alt   = item.getAttribute('data-lb-alt') || '';
        if (!src) return;

        var images = [{ src: src, thumb: thumb, alt: alt }];
        var meta = {
          vehicle:  item.getAttribute('data-lb-vehicle') || '',
          size:     item.getAttribute('data-lb-wheel-size') || '',
          finish:   item.getAttribute('data-lb-finish') || '',
          chassis:  item.getAttribute('data-lb-chassis') || '',
          notes:    item.getAttribute('data-lb-notes') || '',
          shopUrl:  item.getAttribute('data-lb-shop-url') || ''
        };

        Lightbox.open(images, meta, 0);
      });
    });
  }

  /* ══════════════════════════════════════════════════════════════
     MAIN GALLERY PAGE — dependent filters + lightbox trigger
     Cards carry pipe-delimited image lists (Phase 2 metaobject format):
       data-lb-image-srcs   "url1|url2|url3"
       data-lb-image-thumbs "thumb1|thumb2|thumb3"
     Lightbox shows all photos for the clicked build.
     ══════════════════════════════════════════════════════════════ */

  function initMainGallery(section) {
    var grid       = $(section, '.vfw-gal__grid');
    var emptyEl    = $(section, '.vfw-gal__empty');
    var countEl    = $(section, '.vfw-gal__results-count');
    var resetBtn   = $(section, '.vfw-gal__reset');
    var makeSelect = $(section, '[data-filter="make"]');
    var modelSel   = $(section, '[data-filter="model"]');
    var genSel     = $(section, '[data-filter="generation"]');
    var cards      = grid ? $$(grid, '.vfw-gal__card') : [];

    if (!grid || !cards.length) return;

    var db = buildDb(cards);

    if (makeSelect) {
      populateSelect(makeSelect, Object.keys(db).sort(), 'Make');
    }

    function applyFilters() {
      var make  = makeSelect ? makeSelect.value : '';
      var model = modelSel ? modelSel.value : '';
      var gen   = genSel ? genSel.value : '';

      var wheelFilters = {};
      $$(section, '[data-filter]').forEach(function (sel) {
        var key = sel.getAttribute('data-filter');
        if (['make', 'model', 'generation'].indexOf(key) < 0 && sel.value) {
          wheelFilters[key] = sel.value;
        }
      });

      var visible = 0;
      cards.forEach(function (card) {
        var mMatch  = !make  || card.getAttribute('data-make')       === make;
        var moMatch = !model || card.getAttribute('data-model')      === model;
        var gMatch  = !gen   || card.getAttribute('data-generation') === gen;
        var wMatch  = Object.keys(wheelFilters).every(function (k) {
          return card.getAttribute('data-' + k) === wheelFilters[k];
        });
        var show = mMatch && moMatch && gMatch && wMatch;
        card.hidden = !show;
        if (show) visible++;
      });

      if (emptyEl) emptyEl.hidden = visible > 0;
      if (countEl) {
        countEl.textContent = visible + ' build' + (visible !== 1 ? 's' : '') +
          (make ? ' for ' + capitalize(make) : '');
      }
    }

    /* Dependent vehicle filters */
    if (makeSelect && modelSel) {
      makeSelect.addEventListener('change', function () {
        var make = makeSelect.value;
        var models = make && db[make] ? Object.keys(db[make]).sort() : [];
        populateSelect(modelSel, models, 'Model');
        modelSel.disabled = !make;
        if (genSel) { populateSelect(genSel, [], 'Generation'); genSel.disabled = true; }
        applyFilters();
      });
      modelSel.disabled = true;
    }

    if (modelSel && genSel) {
      modelSel.addEventListener('change', function () {
        var make  = makeSelect ? makeSelect.value : '';
        var model = modelSel.value;
        var gens  = make && model && db[make] && db[make][model] ? db[make][model].sort() : [];
        populateSelect(genSel, gens, 'Generation');
        genSel.disabled = !model;
        applyFilters();
      });
      genSel.disabled = true;
    }

    /* Independent wheel filters */
    $$(section, '[data-filter]').forEach(function (sel) {
      var key = sel.getAttribute('data-filter');
      if (['make', 'model', 'generation'].indexOf(key) >= 0) return;
      sel.addEventListener('change', applyFilters);
    });

    /* Reset */
    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        $$(section, '[data-filter]').forEach(function (sel) { sel.value = ''; });
        if (modelSel) { populateSelect(modelSel, [], 'Model'); modelSel.disabled = true; }
        if (genSel)   { populateSelect(genSel,   [], 'Generation'); genSel.disabled = true; }
        applyFilters();
      });
    }

    /* Image button → lightbox */
    $$(section, '.vfw-gal__card-img-btn').forEach(function (btn) {
      var card = btn.closest('.vfw-gal__card');
      if (!card) return;

      btn.addEventListener('click', function (e) {
        e.preventDefault();

        var srcsRaw   = card.getAttribute('data-lb-image-srcs')   || '';
        var thumbsRaw = card.getAttribute('data-lb-image-thumbs') || '';
        var srcs      = srcsRaw.split('|').filter(Boolean);
        var thumbs    = thumbsRaw.split('|').filter(Boolean);
        var vehicle   = card.getAttribute('data-lb-vehicle') || '';

        if (!srcs.length) return;

        var images = srcs.map(function (src, i) {
          return { src: src, thumb: thumbs[i] || src, alt: vehicle || ('Photo ' + (i + 1)) };
        });

        var meta = {
          vehicle:      vehicle,
          make:         card.getAttribute('data-lb-make')          || '',
          model:        card.getAttribute('data-lb-model')         || '',
          generation:   card.getAttribute('data-lb-generation')    || '',
          design:       card.getAttribute('data-lb-wheel-design')  || '',
          size:         card.getAttribute('data-lb-wheel-size')    || '',
          tireSize:     card.getAttribute('data-lb-tire-size')     || '',
          finish:       card.getAttribute('data-lb-finish')        || '',
          chassis:      card.getAttribute('data-lb-chassis')       || '',
          brake:        card.getAttribute('data-lb-brake')         || '',
          backspacing:  card.getAttribute('data-lb-backspacing')   || '',
          notes:        card.getAttribute('data-lb-notes')         || '',
          shopUrl:      card.getAttribute('data-lb-shop-url')      || '',
          productImg:   card.getAttribute('data-lb-product-img')   || '',
          productTitle: card.getAttribute('data-lb-product-title') || '',
          productPrice: card.getAttribute('data-lb-product-price') || ''
        };

        Lightbox.open(images, meta, 0);
      });
    });

    /* Specs panel toggle */
    $$(section, '.vfw-gal__card-specs-toggle').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card  = btn.closest('.vfw-gal__card');
        var panel = card ? card.querySelector('.vfw-gal__card-specs') : null;
        if (!panel) return;
        var isOpen = !panel.hidden;
        panel.hidden = isOpen;
        panel.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        var textEl = btn.querySelector('.vfw-gal__specs-toggle-text');
        /* Labels come from the markup (locale keys), never from this file --
           hardcoded copy is a standing code invariant violation. */
        if (textEl) {
          var showLabel = btn.getAttribute('data-label-show');
          var hideLabel = btn.getAttribute('data-label-hide');
          if (showLabel && hideLabel) textEl.textContent = isOpen ? showLabel : hideLabel;
        }
      });
    });

    applyFilters();
  }

  function buildDb(cards) {
    var db = {};
    cards.forEach(function (card) {
      var make  = card.getAttribute('data-make')  || '';
      var model = card.getAttribute('data-model') || '';
      var gen   = card.getAttribute('data-generation') || '';
      if (!make) return;
      if (!db[make]) db[make] = {};
      if (model) {
        if (!db[make][model]) db[make][model] = [];
        if (gen && db[make][model].indexOf(gen) < 0) db[make][model].push(gen);
      }
    });
    return db;
  }

  function populateSelect(sel, values, placeholder) {
    sel.innerHTML = '<option value="">' + placeholder + '</option>';
    values.forEach(function (val) {
      var opt = document.createElement('option');
      opt.value = val;
      opt.textContent = capitalize(val.replace(/-/g, ' '));
      sel.appendChild(opt);
    });
    sel.value = '';
  }

  function capitalize(str) {
    return str.replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  }

  /* ══════════════════════════════════════════════════════════════
     BOOT
     ══════════════════════════════════════════════════════════════ */

  function boot() {
    $$(document, '[data-vfw-gallery="product"]').forEach(initProductGallery);
    $$(document, '[data-vfw-gallery="main"]').forEach(initMainGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();
